import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { supportTicketInfoDemoData } from '../../../../data';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ApiLoadSupportTicketInfo } from '../SupportTicketOperation';

const SupportTicketInfoContext = createContext();

export const useTicketInfo = () => useContext(SupportTicketInfoContext);

function SupportTicketInfoProvider({ children, id }) {
    const initialState = { SupportTicketId: 0, Message: '', Attachment: [] };

    const [formData, setFormData] = useState(initialState);
    // --Data reload
    const [reloadKey, setReloadKey] = useState(0);
    // --Store initial data
    const [supportTicketInfo, setSupportTicketInfo] = useState(supportTicketInfoDemoData);
    // --Modal open handler
    const [showModal, setShowModal] = useState({
        type: '',
        data: null
    });

    const { setMessage } = useTemplate();

    // -- Load all customer initially
    useEffect(() => {
        ApiLoadSupportTicketInfo(id)
            .then(({ data }) => {
                setSupportTicketInfo(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
                setSupportTicketInfo({});
            });
    }, [setMessage, reloadKey, id]);

    const value = useMemo(() => {
        // -- Reload Button
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            setSupportTicketInfo(supportTicketInfoDemoData);
        };

        const handleChange = (e) => {
            const { name, value: val } = e.target;
            setFormData((prev) => ({ ...prev, [name]: val }));
        };

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };
        return {
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,

            // Support Ticket Data
            supportTicketInfo,
            setSupportTicketInfo,

            // -- Reload
            reloadKey,
            setReloadKey,
            handleReload,

            formData,
            setFormData,
            handleChange
        };
    }, [showModal.type, showModal.data, supportTicketInfo, reloadKey, formData]);

    return (
        <SupportTicketInfoContext.Provider value={value}>
            {children}
        </SupportTicketInfoContext.Provider>
    );
}

export default SupportTicketInfoProvider;
